import { DATE_RANGE_TYPE, ScheduledReport } from '@givelify/api';

export const DATES = Array.from(Array(31).keys()).map((v) => v + 1);

export const dateRangeTypeToTranslationKey = (value: DATE_RANGE_TYPE) => {
    switch (value) {
        case DATE_RANGE_TYPE.BANK_DEPOSITS:
            return 'bankDepositDate';
        default:
        case DATE_RANGE_TYPE.DONATION:
            return 'donationDate';
    }
};

export interface IntegrationState {
    scheduledReport: ScheduledReport;
}

export const SET_SCHEDULED_REPORT = 'SET_SCHEDULED_REPORT';

export interface SetScheduledReport {
    type: typeof SET_SCHEDULED_REPORT;
    data: IntegrationState['scheduledReport'];
}
export type IntegrationActions = SetScheduledReport;
